import { all } from 'redux-saga/effects'
import { watchFetchBusinessCardsSaga } from './business/DashboardSaga'
import { watchFetchLoginSaga } from './common/AuthSaga'
import { watchFetchCreateCampaignSaga } from './business/CampaignSaga'
import { watchViewSubTranctionSaga } from './business/SubtractionSaga'
import { watchFetchAdminCardsSaga, watchFetchThisWeekBusinessSaga, watchFetchThisWeekpaymentsSaga } from './admin/DashboardSaga'
import { watchFetchAllLeadsAdminSaga, watchFetchCreateLeadSaga, watchFetchThisWeekLeadsSaga } from './admin/LeadAdminSaga'
import { watchFetchAllLeadsSaga, watchFetchAllThisWeekLeadsBusinessSaga, watchFetchAllTicketsSaga, watchFetchSubmitDuplicateSaga } from './business/LeadSaga'
import { watchFetchAllTxnAdminSaga } from './admin/TxnAdminSaga';
import { watchFetchAllTxnSaga, watchFetchWalletSaga } from './business/TxnSaga'
import { watchFetchGetBusinessSaga } from './admin/BusinessAdminSaga';
import {watchFetchCreateSubscriptSaga, watchViewSubscriptSaga, watchUpdateSubscriptSaga} from '../sagas/admin/SubscriptionSage'
import {watchChangePasswordSaga} from '../sagas/business/ChangepasswordSage'
import {watchForgotPasswordSaga} from './common/ForgotpasswordsSaga'

export default function* rootSaga() {
    yield all([
        watchFetchBusinessCardsSaga(),
        watchFetchLoginSaga(),
        watchFetchCreateCampaignSaga(),
        watchChangePasswordSaga(),
        watchForgotPasswordSaga(),
        watchFetchAdminCardsSaga(),
        watchViewSubTranctionSaga(),/// Tran
        watchFetchCreateLeadSaga(),
        watchFetchCreateSubscriptSaga(),
        watchViewSubscriptSaga(),
        watchUpdateSubscriptSaga(),
        watchFetchThisWeekLeadsSaga(),
        watchFetchAllLeadsSaga(),
        watchFetchAllLeadsAdminSaga(),
        watchFetchAllTxnAdminSaga(),
        watchFetchAllTxnSaga(),
        watchFetchWalletSaga(),
        watchFetchAllThisWeekLeadsBusinessSaga(),
        watchFetchThisWeekBusinessSaga(),
        watchFetchThisWeekpaymentsSaga(),
        watchFetchGetBusinessSaga(),
        watchFetchSubmitDuplicateSaga(),
        watchFetchAllTicketsSaga(),
    ])
}